import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const storedCultureCode = localStorage.getItem('cultureCode') || 'en-US';

i18n.use(HttpBackend)
    .use(initReactI18next)
    .init({
        lng: storedCultureCode,
        fallbackLng: 'en-US',
        ns: [
            'common',
            'auth',
            'sidebar',
            'dashboard',
            'transactions',
            'moveMoney',
            'crypto',
            'monthlyStatements',
            'security',
            'businessUsers',
            'network',
            'approvals',
            'errors',
            'footer',
            'notifications',
        ],
        defaultNS: 'common',
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: true,
        },
    });

export default i18n;
